var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ship-item",class:[
    { 'ship--disabled': !_vm.active },
    { 'ship--clickeable': _vm.clickeable },
    { 'ship--dense': _vm.dense },
    _vm.predefinedStyle
  ],on:{"click":function($event){_vm.handleClick()}}},[_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }